// src/components/layout/PublicLayout.jsx
import React from 'react';
import Header from './Header';
import Footer from './Footer';

const PublicLayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
     <main className="flex-grow pt-[72.2px]"> {/* pt-20 to account for fixed header */}
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default PublicLayout;